/* eslint-disable @typescript-eslint/no-var-requires */
import { THEME_NAME } from 'utils/helperConfig'
const { variables } = require(`../${THEME_NAME}/theme`)

export const baseFormTheme = {
    components: {
        MuiTypography: {
            styleOverrides: {
                h1: {
                    fontSize: 28,
                    fontWeight: 600,
                },
                h4: {
                    fontSize: 20,
                    lineHeight: '24px',
                    fontWeight: 600,
                    color: `${variables.color.text.main}`,
                },
                h5: {
                    fontSize: 16,
                    lineHeight: '18px',
                    fontWeight: 400,
                },
                subtitle1: {
                    color: `${variables.color.text.main}`,
                    fontSize: 16,
                    lineHeight: '20px',
                    fontWeight: 600,
                },
                subtitle2: {
                    color: `${variables.color.text.secondary}`,
                    fontSize: 16,
                    lineHeight: '20px',
                    fontWeight: 400,
                },
                body1: {
                    color: `${variables.color.text.secondary}`,
                    fontSize: 16,
                    lineHeight: '20px',
                    fontWeight: 400,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontSize: 14,
                    fontWeight: 600,
                },
                outlined: {
                    '&:hover, &:active': {
                        backgroundColor: `${variables.color.buttonContainedSecondary.main}`,
                    },
                },
                contained: {
                    fontWeight: 600,
                    '&:hover, &:active': {
                        backgroundColor: `${variables.color.buttonContained.hover}`,
                        boxShadow:
                            '0px 2px 4px -1px rgba(0,0,0,0.06), 0px 4px 5px 0px rgba(0,0,0,0.06), 0px 1px 10px 0px rgba(0,0,0,0.02);',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: `${variables.color.buttonContained.disabled}`,
                        opacity: '0.3',
                        color: `${variables.color.buttonContained.disabledText}`,
                    },
                },
                containedSecondary: {
                    backgroundColor: `${variables.color.buttonContainedSecondary.main}`,
                    color: `${variables.color.buttonContainedSecondary.mainText}`,
                    borderRadius: `${variables.variables.buttonOutlined.borderRadius}`,
                    height: 38,
                    fontSize: 16,
                    fontWeight: 600,
                    lineHeight: '20px',
                    boxShadow: 'none',
                    padding: '6px 23px',
                    textTransform: 'none',

                    '&.Mui-disabled': {
                        backgroundColor: `${variables.color.buttonContainedSecondary.disabled}`,
                        opacity: '0.3',
                        color: `${variables.color.buttonContainedSecondary.disabledText}`,
                    },

                    '&:hover, &:active': {
                        backgroundColor: `${variables.color.buttonContainedSecondary.hover}`,
                        boxShadow: '0px 0px 0px -1px rgba(0,0,0,0.04), 0px 3px 3px 0px rgba(0,0,0,0.04), 0px 1px 3px 0px rgba(0,0,0,0.02);',
                    },
                },
                label: {
                    textAlign: 'left',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    height: '1.7275em',
                    '&::-webkit-input-placeholder': {
                        fontSize: 16,
                    },
                    '&::-moz-placeholder': {
                        fontSize: 16,
                    },
                    '&:-ms-input-placeholder': {
                        fontSize: 16,
                    },
                    '&:-moz-placeholder': {
                        fontSize: 16,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    color: `${variables.color.text.main}`,

                    '&.Mui-focused fieldset': {
                        borderColor: `${variables.color.border.active} !important`,
                        borderWidth: '2px !important',
                    },

                    '&.Mui-error fieldset': {
                        borderWidth: '2px !important',
                        borderColor: `${variables.color.error.main} !important`,
                    },

                    '&.Mui-error .MuiSelect-select': {
                        color: `${variables.color.error.main}`,
                    },

                    '&.Mui-focused .formControlInputAdornment, &.Mui-focused .ledgerLogoInputAdornment .separator': {
                        borderColor: `${variables.color.border.main}`,
                    },
                    '&:hover fieldset': {
                        borderColor: `${variables.color.border.main}`,
                    },
                    '&:hover .formControlInputAdornment, &:hover .ledgerLogoInputAdornment .separator': {
                        borderColor: `${variables.color.border.main}`,
                    },
                    '& .formControlInputAdornment fieldset': {
                        border: 'none',
                    },
                    '& .formControlInputAdornment': {
                        borderLeft: `1px solid ${variables.color.border.main}`,
                        cursor: 'default',
                        minWidth: 100,
                    },
                    '& .ledgerLogoInputAdornment .separator': {
                        borderLeft: `1px solid ${variables.color.border.main}`,
                    },
                    '&.Mui-disabled > input:not(.MuiSelect-nativeInput)': {
                        backgroundColor: `${variables.color.input.disabled}`,
                        color: `${variables.color.input.disabledText}`,
                        WebkitTextFillColor: `${variables.color.input.daisabledFillColor}`,
                        opacity: `${variables.color.input.disabledOpacity}`,
                        fontWeight: `${variables.color.input.daisabledFontWeight}`,
                    },
                    '&.Mui-disabled': {
                        paddingRight: 0,
                    },

                    '& .MuiSelect-icon.Mui-disabled': {
                        display: 'none',
                    },

                    '&.Mui-disabled > .MuiSelect-select': {
                        WebkitTextFillColor: `${variables.color.input.daisabledFillColor}`,
                    },
                    '& .inputAdornmentSelectDisabled': {
                        pointerEvents: 'none',
                    },
                    '& .inputAdornmentSelectDisabled > svg': {
                        display: 'none',
                    },
                },
                input: {
                    padding: '11.2px 14px',
                    MozAppearance: 'textfield',
                    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                    },
                },
            },
        },
        MuiButtonGroup: {
            styleOverrides: {
                grouped: {
                    justifyContent: 'left',
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                // root: {
                //     color: `${variables.color.text.placeholder}`,
                //     fontSize: 16,
                //     '&.Mui-focused': {
                //         color: `${variables.color.border.active}`,
                //     },
                // },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&[data-shrink="false"]': {
                        top: '-2px',
                        fontSize: '16px',
                    },
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    '&.inputAdornmentLeftSelect': {
                        top: '50%',
                        position: 'absolute',
                        left: 7,
                    },
                    '&.inputAdornmentRightSelectButton': {
                        position: 'absolute',
                        right: 0,
                        width: '95px',
                        minHeight: '50px',
                        display: 'flex',
                        justifyContent: 'center',
                        borderTop: `1px solid #a8a8a8`,
                        borderRight: `1px solid #a8a8a8`,
                        borderBottom: `1px solid #a8a8a8`,
                        cursor: 'pointer',
                        borderBottomRightRadius: 4,
                        borderTopRightRadius: 4,

                        '&:hover': {
                            border: `1px solid #000`,
                        },

                        '& > p': {
                            color: `${variables.color.buttonContainedSecondary.mainText}`,
                            fontWeight: 600,
                        },
                    },
                },
            },
        },
        PrivateTabIndicator: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: `${variables.color.border.active}`,
                    height: 2,
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                flexContainer: {
                    borderBottom: `1px solid ${variables.color.border.main}`,

                    '& > button:hover': {
                        backgroundColor: '#F8F9FA',
                        color: `${variables.color.text.main}`,
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minWidth: '90px !important',
                    paddingLeft: 25,
                    paddingRight: 25,
                    fontSize: 16,

                    '@media (max-width: 600px)': {
                        minWidth: 'unset !important',
                        paddingLeft: 20,
                        paddingRight: 20,
                    },
                },
                wrapper: {
                    fontWeight: 400,
                    fontSize: 16,
                    lineHeight: '20px',
                },
                textColorPrimary: {
                    color: `${variables.color.text.secondary}`,
                    '&.Mui-selected': {
                        color: `${variables.color.text.main}`,
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiBox: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    position: 'relative',
                    '&.ledgerLogoInputAdornment': {
                        position: 'absolute',
                        right: 0,
                    },
                },
                marginNormal: {
                    marginTop: 30,
                    marginBottom: 0,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        position: 'absolute',
                        bottom: '-22px',
                        marginLeft: 0,
                        color: `${variables.color.error.main}`,
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginRight: 0,
                    alignItems: 'center',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: `${variables.color.text.main}`,
                    fontWeight: 600,
                    cursor: 'pointer',
                },
                underlineAlways: {
                    textDecorationColor: `${variables.color.text.main}`,
                },
                underlineHover: {
                    color: `${variables.color.text.main}`,
                    fontWeight: 600,
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecoration: 'none',
                    },
                },
                underlineNone: {
                    color: `${variables.color.text.main}`,
                    fontWeight: 600,
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
                button: {
                    textDecoration: 'none',
                    color: variables.color.link.active,
                    fontSize: 16,
                    fontWeight: '600',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: `${variables.color.text.main}`,
                    color: '#ffffff',
                    fontSize: 12,
                    fontWeight: 600,
                },
                arrow: {
                    color: `${variables.color.text.main}`,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                elevation1: {
                    boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
                },
                rounded: {
                    borderRadius: `${variables.variables.paper.borderRadius}`,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: 16,
                    lineHeight: '20px',
                },
                head: {
                    fontWeight: 600,
                    color: `${variables.color.text.main}`,
                    whiteSpace: 'nowrap',
                },
                body: {
                    fontWeight: 400,
                    color: `${variables.color.text.secondary}`,
                    whiteSpace: 'nowrap',
                    borderBottom: 'none',
                },
                footer: {
                    borderTop: '1px solid #dddddd',
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    width: '100%',
                    padding: 0,
                    overflowX: 'initial',
                    borderRadius: `${variables.variables.paper.borderRadius}`,

                    '&::-webkit-scrollbar-thumb': {
                        background: `${variables.color.text.placeholder}`,
                    },
                    '&::-webkit-scrollbar': {
                        height: 8,
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#E9ECEF',
                        boxShadow: 'none',
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                hover: {
                    '&:hover': {
                        backgroundColor: '#F8F9FA !important',
                    },
                },
            },
        },
        NuiTable: {
            styleOverrides: {
                root: {
                    boxShadow: '0 0 8px 0 rgba(154, 154, 154, 0.1)',
                },
            },
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    '&.verticalScrollable': {
                        width: '100%',
                        overflowY: 'hidden',

                        '&::-webkit-scrollbar-thumb': {
                            background: `${variables.color.text.placeholder}`,
                        },
                        '&::-webkit-scrollbar': {
                            height: 6,
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#E9ECEF',
                            boxShadow: 'none',
                        },
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: `${variables.color.button.radioBorder}`,

                    '&:hover': {
                        backgroundColor: 'rgba(35, 182, 236, 0.06)',
                    },

                    '&$checked': {
                        color: `${variables.color.button.radioActive}`,

                        '& + span': {
                            fontWeight: '600',
                            color: `${variables.color.button.radioActiveText}`,
                        },

                        '&:hover': {
                            backgroundColor: 'rgba(35, 182, 236, 0.06)',
                        },
                    },
                },
                colorSecondary: {
                    color: `${variables.color.button.radioBorder}`,

                    '&:hover': {
                        backgroundColor: 'rgba(35, 182, 236, 0.06)',
                    },

                    '&$checked': {
                        color: `${variables.color.button.radioActive}`,

                        '& + span': {
                            fontWeight: '600',
                            color: `${variables.color.button.radioActiveText}`,
                        },

                        '&:hover': {
                            backgroundColor: 'rgba(35, 182, 236, 0.06)',
                        },
                    },
                },
            },
        },
        PrivateRadioButtonIcon: {
            styleOverrides: {
                root: {
                    '& > svg': {
                        height: 28,
                        width: 28,
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    minHeight: '1.7275em',
                    lineHeight: '1.7275em',
                },
                selectMenu: {
                    color: `${variables.color.text.main}`,
                    fontSize: 16,
                    fontWeight: '600',
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    overflow: 'hidden',
                    '& button': {
                        padding: 2,
                    },
                },
                input: {
                    marginRight: 16,
                },
                button: {
                    padding: 6,
                },
                select: {
                    paddingBottom: 3,
                    fontWeight: 400,
                },
                spacer: {
                    display: 'none',
                },
                toolbar: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '0 30px',
                    minHeight: 48,
                },
                selectRoot: {
                    marginRight: 'auto',
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginTop: 8,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    padding: '3.7px 14px',
                },
                input: {
                    padding: '2px 0',
                },
                popper: {
                    boxShadow: `rgb(154 154 154 / 10%) 0px 3px 5px 0px, rgb(154 154 154 / 10%) 0px 3px 3px 1px, rgb(154 154 154 / 50%) 0px 3px 20px 2px`,
                    borderRadius: `${variables.variables.input.borderRadius}`,
                },
            },
        },
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                root: {
                    '& .MuiTypography-subtitle1': {
                        textTransform: 'capitalize',
                    },
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                track: {
                    opacity: 1,
                    '.Mui-disabled.Mui-disabled + &': {
                        opacity: 1,
                    },
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    color: '#999999',
                    fontSize: '16px',
                    fontWeight: 400,
                    '&.Mui-active': {
                        fontWeight: 600,
                        color: `${variables.color.text.main}`,
                    },
                },
            },
        },
    },
}
